/**
 * The frame of a Wix app's own first step (WhatsApp, Instagram, product catalog, order tracking). The step hands its
 * pieces over and the onboarding draws them: the Wix apps' onboarding (pages/wix-apps/WixAppOnboarding.js) in the main
 * Wix onboarding's look (white card, back button in the title row, the continue button below the card), this default
 * in the agent-creation look (header, body, StepFooter).
 *
 *   title, titleIcon, titleClass  heading and its small icon
 *   sub                           one line under the heading
 *   bodyClass, children           the step's own content
 *   primary {label, onClick, disabled, busy}   the continue button
 *   skip {label, onClick} | null               "connect later" and the like
 *   hint                                       a short neutral note (e.g. "keeps syncing in the background")
 */
import StepFooter from './StepFooter';

export function legacyFrame({ title, titleIcon = null, titleClass = '', sub, bodyClass = '', children, primary, skip = null, hint = null }) {
  return <>
    <header className="ac-head">
      <h2 className={`ac-title ${titleClass}`}>{titleIcon}{title}</h2>
      {sub && <p className="ac-sub">{sub}</p>}
    </header>
    <div className={`ac-body ${bodyClass}`}>{children}</div>
    <StepFooter primaryLabel={primary.label} onPrimary={primary.onClick}
      onSkip={skip ? skip.onClick : undefined} skipLabel={skip?.label}
      disabled={primary.disabled} busy={primary.busy} hint={hint} />
  </>;
}
